import infoCircle from "../assets/info-circle.svg";

const CodeSnippet = ({
    values = {},
    errors = {},
    touched = {},
    handleChange = () => { },
    handleBlur = () => { }
}) => (
    <div className="theme-card p-4 mb-3">
        <div className="card-title pb-3">Code Snippets</div>

        <div className="frm-group">
            <label className="frm-label d-flex align-items-center">
                Head Tag
                <img className="ms-2" src={infoCircle} alt="Info" title="Add Head Tag" />
            </label>

            <textarea
                name="codesnippet"
                className="frm-input"
                rows={3}
                placeholder="Enter Head Tag"
                value={values.codesnippet || ""}
                onChange={handleChange}
                onBlur={handleBlur}
            />

            {touched.codesnippet && errors.codesnippet && (
                <div className="input-error">{errors.codesnippet}</div>
            )}
        </div>
    </div>
);

export default CodeSnippet;